import classNames from 'classnames';
import styles from './input.module.scss';
import {forwardRef} from 'react';
import {PlatformIntl} from 'src/infra/PlatformIntl';

interface TextInputProps {
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  name: string;
  // onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  // onBlur: () => void;
  // ref
}

const intl = PlatformIntl.getInstance();

export const TextInput = forwardRef(({
  placeholder = intl.formatMessage('sharedTypeHere'),
  className,
  ...rest
}: TextInputProps, ref) => {
  return (
    <input
      // @ts-ignore
      ref={ref}
      type="text"
      className={classNames(styles.input, styles.border, styles.spacing, className)}
      placeholder={placeholder}
      {...rest}
    />
  );
});
